import React, { useState, useEffect } from 'react';
//ui components
import Logo from '../static/image/logoNew.png';
//utils
import { decodedJWTPayload } from '../utils/commonUtil';

function TopNav() {
  const [userDN, setUserDN] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const res = decodedJWTPayload(token);
        setUserDN(res?.dn);
      } catch (error) {
        console.error();
      }
    }
  }, []);

  return (
    <div
      bg='dark'
      variant="dark"
      className="top-nav"
      style={{
        backgroundColor: '#ED1A3D',
        height: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px'
      }}
    >
      <img style={{ height: '30px' }} src={Logo} alt='' />
      {userDN && (
        <div style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '10px' }}>Welcome</span>
          <span style={{ fontWeight: 'bold' }}>{userDN}</span>
        </div>
      )}
    </div>
  );
}

export default TopNav;
